export default {
    init() {
        // JavaScript to be fired on the login page

        jQuery("#wp-submit").click(function() {
            var user = jQuery("input#loginemail").val();
            var pass = jQuery("input#loginpassword").val();

            if ( (user === "") || (typeof user === "undefined") ) {
                jQuery("input#loginemail").focus();
                return false;
            }
            if ( (pass === "") || (typeof pass == "undefined") ) {
                jQuery("input#loginpassword").focus();
                return false;
            }

        });

    },
};




// WEBPACK FOOTER //
// ./scripts/routes/login.js